<div class="col-12">
    <p-messages></p-messages>
    <p-toast key="tst"></p-toast>
    <div class="grid">
        <div class="col-12">
            <h3 style="text-align: center;">Rental Refi Loan</h3>
        </div>
        <div class="col-12">
            <h6>Contact Details:</h6>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="firstName" pInputText> 
                <label for="float-input">First Name <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="lastName" pInputText> 
                <label for="float-input">Last Name <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="phone" pInputText> 
                <label for="float-input">Phone Number <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="email" pInputText> 
                <label for="float-input">Email Address <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedProperty" pInputText> 
                <label for="float-input">Interested Property Address <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedCity" pInputText> 
                <label for="float-input">Interested Property City <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedState" pInputText> 
                <label for="float-input">Interested Property State <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedZip" pInputText> 
                <label for="float-input">Interested Property Zip <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="ficoScore" pInputText> 
                <label for="float-input">Your FICO Score (min 640 allowed) <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="referralSource" pInputText> 
                <label for="float-input">How Did You Find CK Capital? <span style="color:red">*</span></label>
            </span>
        </div>


        <div class="col-12">
            <h6>Loan Details:</h6>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="estimatedAsIs" pInputText> 
                <label for="float-input">Estimated AS-IS Value <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="grossRents" pInputText> 
                <label for="float-input">Gross Monthly Rents <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="annualTaxes" pInputText> 
                <label for="float-input">Annual Taxes <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="annualHazard" pInputText> 
                <label for="float-input">Annual Hazard Insurance <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="annualHOA" pInputText> 
                <label for="float-input">Annual HOA's <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="annualFlood" pInputText> 
                <label for="float-input">Annual Flood Insurance <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="payoff" pInputText> 
                <label for="float-input">Payoff (put 0 if no payoff) <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6 p-fluid" style="margin-top:-12px">
            <label for="basic">Date of Purchase</label>
            <p-calendar inputId="basic" [(ngModel)]="dateOfPurchase" ></p-calendar>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="originalPurchasePrice" pInputText> 
                <label for="float-input">Original Purchase Price <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <p-dropdown [options]="yesno" [style]="{'width': '100%'}" [(ngModel)]="wasRehabCompletedAfterPurch" [showClear]="true" optionLabel="name" placeholder="Was a Rehab Completed After Purchase?"></p-dropdown>
        </div>
        <div *ngIf="wasRehabCompletedAfterPurch && wasRehabCompletedAfterPurch.name == 'Yes'" class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="rehabBudget" pInputText> 
                <label for="float-input">What Was Your Budget for the Rehab?</label>
            </span>
        </div>
        <div *ngIf="wasRehabCompletedAfterPurch && wasRehabCompletedAfterPurch.name == 'Yes'" class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="actualRehabSpend" pInputText> 
                <label for="float-input">How Much Did You Actually Spend on the Rehab?</label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <p-dropdown [options]="yesno" [style]="{'width': '100%'}" [(ngModel)]="hasBeenListedInLast6Months" [showClear]="true" optionLabel="name" placeholder="Has This Property Been Listed in the Last 6 Months?"></p-dropdown>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <p-dropdown [options]="propertyTypes" [style]="{'width': '100%'}" [(ngModel)]="propertyType" [showClear]="true" optionLabel="name" placeholder="Type of Property"></p-dropdown>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="rentalsInLast36Months" pInputText> 
                <label for="float-input">How Many Rentals Purchased in Last 36 Months?</label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="propertiesOwnedFlipped36Months" pInputText> 
                <label for="float-input">How Many Properties Owned/Flipped in Last 36 Months?</label>
            </span>
        </div>
    </div>

    <p-messages></p-messages>
    <button pButton [disabled]="runningNumbers" label="RUN MY NUMBERS" icon="pi pi-check-square" class="p-button-lg pt-3" (click)="runRentalRefiNumbers()"><i *ngIf="runningNumbers" class="pi pi-spin pi-spinner"></i></button>
</div>
